import styled, { StyledComponentProps } from 'styled-components'
import { NoSelectStyles } from '../shared/styled/NoSelectStyles.styled'

interface IProps {
    active?: boolean
}

export const StyledArticlesIcon = (props: IProps & StyledComponentProps<'svg', any, {}, never>) => {
    return (
        <StyledSvg viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="9.08387" y="6.95887" width="15.8323" height="20.0823" rx="0.586132" strokeWidth="1.16774" />
            <path d="M12.75 17L19.125 17" strokeWidth="1.16774" strokeLinecap="round" />
            <path d="M12.75 11.6875L17 11.6875" strokeWidth="1.16774" strokeLinecap="round" />
            <path d="M12.75 22.3125L21.25 22.3125" strokeWidth="1.16774" strokeLinecap="round" />
        </StyledSvg>
    )
}

const StyledSvg = styled.svg<IProps>`
    ${NoSelectStyles}

    width: 30px;
    height: 30px;
    stroke: ${p => (p.active ? p.theme.playColor : p.theme.textColor)};
`
